import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import styles from './CCTVMonitor.module.css';
import CameraView from './CameraView';
import { cctvRequester } from 'App';

const CCTVMonitor = () => {
    const [cameras, setCameras] = useState([]);
    const [error, setError] = useState(null);
    const [currentStoreIndex, setCurrentStoreIndex] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);
    const { token } = useSelector((state) => state.auth);

    // 카메라를 store_code별로 그룹화
    const groupedCameras = _.groupBy(cameras, 'store_code');
    const storeGroups = Object.keys(groupedCameras).sort();

    useEffect(() => {
        const fetchCameras = async () => {
            try {
                const cameraList = await cctvRequester.getCameraList(token);
                setCameras(cameraList);
            } catch (err) {
                setError('Failed to fetch camera list');
                console.error(err);
            }
        };

        if (token) {
            fetchCameras();
        }

        return () => {
            // 컴포넌트 언마운트 시 모든 카메라 스트림 정리
            setCameras([]);
        };
    }, [token]);

    useEffect(() => {
        if (!autoPlay || storeGroups.length === 0) return;

        const interval = setInterval(() => {
            setCurrentStoreIndex((prev) => (prev + 1) % storeGroups.length);
        }, 10000);

        return () => clearInterval(interval);
    }, [autoPlay, storeGroups.length]);

    const handleStoreClick = (index) => {
        setCurrentStoreIndex(index);
        setAutoPlay(false);
    };

    if (!token) {
        return <div>Authentication required</div>;
    }

    const currentStoreCode = storeGroups[currentStoreIndex];
    const currentStoreCameras = groupedCameras[currentStoreCode] || [];

    return (
        <div className={styles.container}>
            <div className={styles.controlBar}>
                <div className={styles.buttonGroup}>
                    {storeGroups.map((storeCode, index) => (
                        <button
                            key={storeCode}
                            onClick={() => handleStoreClick(index)}
                            className={`${styles.storeButton} ${currentStoreIndex === index ? styles.storeButtonActive : ''
                                }`}
                        >
                            Store {storeCode}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setAutoPlay(!autoPlay)}
                    className={`${styles.autoPlayButton} ${autoPlay ? styles.autoPlayButtonActive : styles.autoPlayButtonInactive
                        }`}
                >
                    {autoPlay ? 'Auto Play ON' : 'Auto Play OFF'}
                </button>
            </div>

            <div className={styles.gridContainer}>
                {currentStoreCameras.map((camera) => (
                    <CameraView
                        key={camera.id}
                        camera={camera}
                        token={token}
                    />
                ))}
                {currentStoreCameras.length === 0 && (
                    <div className={styles.noCamera}>
                        No cameras found for store {currentStoreCode}
                    </div>
                )}
            </div>

            {error && <div className={styles.error}>{error}</div>}
        </div>
    );
};

export default CCTVMonitor;